import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { GET_PAYMENT_ACCOUNT } from "./getPaymentAccount";

const REMOVE_PAYMENT_CONNECTION = gql(`
  mutation REMOVE_PAYMENT_CONNECTION($organizationSlug: String!){
  paymentAccountDelete(organizationSlug: $organizationSlug) {
    __typename
    ... on PaymentAccountDeleted {
      organizationID
    }
    ... on PaymentAccountNotFound {
      organizationID
    }
    ... on PaymentAccountHasActiveSubscriptions {
      organizationID
      activeSubscriptionsCount
    }
  }}
`);

export function useRemovePaymentConnection() {
  return useMutation(REMOVE_PAYMENT_CONNECTION, {
    refetchQueries: [GET_PAYMENT_ACCOUNT]
  });
}
